<template>
  <div class="order-modal" :class="{
      'order-modal_large': large,
    }">
    <edit-application
      v-if="showModal"
      :dataEmployee="order"
      :large="large"
      @updateRequest="updateRequest"
      @openDeleteModal="openDeleteModal"
      @closeModal="closeModal"
      @rejectOrder="rejectOrder"
    />

    <modal :show="showModalDelete" :showBtn="false" :dark="true" @close="toggleDeleteModal">
      <delete-modal
        :title="$t('calendar.deleteTitle')"
        @cancel="toggleDeleteModal"
        @next="removeAction"
      />
    </modal>

    <div v-if="isGenerating" class="preloader">
      <div class="preloader__title">{{ $t("ordersStatus.attachmentsGenerating") }}</div>
      <div class="preloader__box"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'orders-modal',
    props: {
        large: {
            required: false,
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showModalDelete: false,
            id: null,
            isGenerating: false,
            orderStatus: null,
        }
    },
    computed: {
        ...mapGetters({
            order: 'orders/orderGetters',
            showModal: 'orders/showModal',
        }),
    },
    methods: {
        ...mapMutations({
            toggleModal: 'orders/setToggleModal',
            clearParams: 'orders/clearParams',
            clearOrders: 'orders/clearOrders',
            setToggleModal: 'orders/setToggleModal',
            setSnackbarShow: 'orders/setSnackbarShow',
            setSnackbarData: 'orders/setSnackbarData',
        }),
        ...mapActions({
            updateRequestDetails: 'updateRequestDetails',
            updateRequestStatus: 'updateRequestStatus',
            updateRequestService: 'orders/updateRequestService',
            updateRequestComment: 'updateRequestComment',
            sendRequestInvoice: 'sendRequestInvoice',
            deleteRequest: 'deleteRequest',
            fetch: 'orders/fetch',
            fetchWithSavingScrollState: 'orders/fetchWithSavingScrollState',
            fetchById: 'orders/fetchById',
            addTags: 'orders/addTags',
            addMaterials: 'orders/addMaterials',
            createClient: 'createClient',

            rejectOrderWithReason: 'orders/rejectOrder',
        }),
        async rejectOrder(data) {
            const isOkey = await this.rejectOrderWithReason(data)
            if (!isOkey) return

            await this.fetchWithSavingScrollState()

            this.toggleModal()
            this.setSnackbarData({ id: data.id })
            this.setSnackbarShow(true)
            this.$emit('done')
        },
        async updateRequest(id, data) {
            if (data.paymnet_type !== undefined) {
                this.isGenerating = true
            }

            if (!data.client_id) {
                data.contact.address = data.address
                const clientResponse = await this.createClient(data.contact)

                if (clientResponse.status !== 201) return
                data.client_id = clientResponse.data.id
            }

            if (
                data.status === 'new'
        || data.status === 'stand_by'
        || data.status === 'confirmed'
            ) {
                await this.updateRequestService({
                    id,
                    service_id: data.service_id,
                })
            }

            const { status } = await this.updateRequestDetails({ id, data })
            const isUpdatedComment = await this.updateRequestComment({
                id,
                comment: data.comment,
            })

            if (status !== 200 || !isUpdatedComment) return

            const isUpdatedStatus = this.orderStatus !== data.status
                ? await this.updateRequestStatus({
                    id,
                    status: data.status,
                })
                : true

            if (!isUpdatedStatus) return

            await this.sendInvoice(id, data)
            await this.fetchWithSavingScrollState()

            if (data.tags.length > 0) {
                await this.addTags({
                    id,
                    form: {
                        work_tags: data.tags,
                    },
                })
            }
            this.$store.commit('setUpdateCalendar')
            await this.fetchById(id)
            this.isGenerating = false

            if (data.paymnet_type !== undefined) {
                return
            }

            this.addMaterials({ id, form: { materials: data.materials } })

            this.toggleModal()
            this.setSnackbarData({ id })
            this.setSnackbarShow(true)
            this.$emit('done')
        },
        async sendInvoice(id, data) {
            if (data.paymnet_type !== undefined) {
                await this.sendRequestInvoice(id)
            }
        },
        toggleDeleteModal() {
            this.showModalDelete = !this.showModalDelete
        },
        openDeleteModal(id) {
            this.toggleDeleteModal()
            this.id = id
        },
        async removeAction() {
            await this.deleteRequest(this.id)
            this.toggleDeleteModal()

            this.clearParams()
            this.clearOrders()

            await this.fetch({ page: 1 })
            this.$store.commit('setUpdateCalendar')
            this.setToggleModal()
            this.$emit('done')
        },
        closeModal() {
            this.$emit('closeOrderModal')
            this.toggleModal()
        },
    },
    mounted() {
        this.orderStatus = this.order.status
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.order-modal {
  max-width: 475px;
  border-radius: 4px;
  position: relative;

  border-left: 1px solid var(--border-color);
  border-right: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);

  &_large {
    max-width: 870px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
